<template>
  <Layout>
    <router-view></router-view>
  </Layout>
</template>

<script>
import Layout from "@/layouts/main.vue";
import { layoutMethods } from "@/state/helpers";
import RefreshTokenService from "./services/refreshTokenService";
import { routingProcess } from "@/helpers/routeHelper";
const refreshTokenService = new RefreshTokenService();
export default {
  name: "App",
  components: {
    Layout,
  },
  async created() {
    let expiresec = this.$store.state.layout.tokenRemaining;

    this.swaltimer = 60000;

    if (expiresec > 0) {
      this.countDownTimer2();
    }
    this.countDownTimer();
  },
  data() {
    return {
      countDown: 0,
      swaltimer: 0,
      logoutValue: "",
    };
  },
  methods: {
    ...layoutMethods,
    countDownTimer() {
      if (this.$store.state.layout.count > 0) {
        setTimeout(() => {
          this.changecounterAzalt();
          this.countDownTimer();
        }, 1000);
      } else {
        this.$swal.fire({
          title: "UYARI",
          html:
            'Oturum Sürenizin dolmasına <strong id="timerText"></strong> saniye kalmıştır.<br/><br/>' +
            '<button id="stop" class="btn btn-success">' +
            "Oturum Sürem Uzasın" +
            "</button><br/><br/>" +
            '<button id="resume" class="btn btn-danger">' +
            "Çıkış yapmak istiyorum" +
            "</button><br/><br/>",
          timer: this.swaltimer,
          didOpen: () => {
            const content = this.$swal.getHtmlContainer();
            const $ = content.querySelector.bind(content);

            const stop = $("#stop");
            const resume = $("#resume");
            const timerText = $("#timerText");

            this.$swal.showLoading();

            // function toggleButtons() {
            //   stop.disabled = !this.$swal.isTimerRunning()
            //   resume.disabled = this.$swal.isTimerRunning()
            // }

            stop.addEventListener("click", async () => {
              //this.$store.commit("resetCounter");
              this.changeresetCounter();

              this.$swal.close();
              this.countDownTimer();
            });

            resume.addEventListener("click", () => {
              localStorage.clear();

              window.location.replace(
                `${process.env.VUE_APP_BACKEND_URL}/api/Identity/Auth/Logout`
              );
            });

            setInterval(() => {
              timerText.textContent = (
                this.$swal.getTimerLeft() / 1000
              ).toFixed(0);
            }, 100);
          },
          willClose: () => {
            let remaining = this.$store.state.layout.count;

            if (remaining === 0) {
              localStorage.clear();

              window.location.replace(
                `${process.env.VUE_APP_BACKEND_URL}/api/Identity/Auth/Logout`
              );
            }
          },
        });
      }
    },

    async countDownTimer2() {
      if (this.$store.state.layout.tokenRemaining > 0) {
        setTimeout(() => {
          //this.$store.state.layout.tokenRemaining -= 1
          this.changetokenAzalt();
          this.countDownTimer2();
        }, 1000);
      } else {
        let result = await refreshTokenService.refreshToken();
        let token = result.data.responseData;
        localStorage.setItem("token", token);
        await routingProcess();

        this.countDownTimer2();
      }
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
